// extracted by mini-css-extract-plugin
export default {"drop":"drop__HmXGm","drop--overlayed":"drop--overlayed__RW9Bg","drop--dragover":"drop--dragover__LArvy","fadein":"fadein__jrtni","drop__input":"drop__input__5DEqw"};